import { render } from "./MailTemplates.vue?vue&type=template&id=6ceb37bc&scoped=true"
import script from "./MailTemplates.vue?vue&type=script&lang=js"
export * from "./MailTemplates.vue?vue&type=script&lang=js"

import "./MailTemplates.vue?vue&type=style&index=0&id=6ceb37bc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ceb37bc"]])

export default __exports__